import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

function DocumentClaimsChunkComponent({ chunk }) {
  const regxsToRemove = [/<Desc\/Clms.*?>/g];
  return <InnerHTML tag="span" className="claims-chunk" html={chunk} regxsToRemove={regxsToRemove} />;
}

DocumentClaimsChunkComponent.propTypes = {
  chunk: PropTypes.string.isRequired,
};

export default DocumentClaimsChunkComponent;
